// extracted by mini-css-extract-plugin
module.exports = {"root":"radio-description_root__sM5rE"};